import { CONTENT_CLASSES } from '../constants/classNames';

/**
 * Written sections of an article, each with its own heading: [{ heading, paragraphs }].
 */
export default function ArticleSections({ sections }) {
  return sections.map(({ heading, paragraphs }) => (
    <section key={heading} className={CONTENT_CLASSES.section}>
      <h2 className={CONTENT_CLASSES.sectionTitle}>{heading}</h2>
      {paragraphs.map((paragraph) => (
        <p key={paragraph.slice(0, 40)} className={CONTENT_CLASSES.text}>
          {paragraph}
        </p>
      ))}
    </section>
  ));
}
